import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Announcement from "../components/Announcement";
import Slider from "../components/Slider";
import Categories from "../components/Categories";
import Products from "../components/Products";
import { styled } from "styled-components";
import VideoSlider from "../components/VideoSlider";
import Appointment from "../components/Appointment";
import Portfolios from "../components/Portfolios";
import AboutUs from "../components/AboutUs";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";

const Home = () => {
  const [activeComponent, setActiveComponent] = useState("");
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [isBottomScreen, setIsBottomScreen] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  const hash = window.location.hash.substring(1);
  let hideTimeout;

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveComponent(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    const components = [
      "videoSlider",
      "categories",
      "portfolios",
      "portfoliosSection",
      "aboutUs",
      "appointment",
      "products",
    ];

    components.forEach((id) => {
      const ref = document.getElementById(id);
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollIconBackgroundColor =
    activeComponent === "videoSlider" ||
    activeComponent === "categories" ||
    activeComponent === "appointment" ||
    (isMobile && activeComponent === "aboutUs")
      ? "#f5fbfd"
      : "black";

  const scrollIconColor =
    activeComponent === "videoSlider" ||
    activeComponent === "categories" ||
    activeComponent === "appointment" ||
    (isMobile && activeComponent === "aboutUs")
      ? "black"
      : "white";

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  const showScrollIndicator = () => {
    if (isBottomScreen) {
      return null;
    } else {
      setShowScrollDown(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setShowScrollDown(false);
      }, 2000);
    }
  };

  const handleScroll = (_event) => {
    const target = _event.target;
    const targetChanges = target.scrollHeight - target.scrollTop;
    if (targetChanges - target.clientHeight < 1) {
      setShowScrollDown(false);
      setIsBottomScreen(true);
    } else {
      setIsBottomScreen(false);
    }
  };

  useEffect(() => {
    const handleMouseMove = () => {
      showScrollIndicator();
    };

    const handleTouchStart = () => {
      showScrollIndicator();
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchstart", handleTouchStart);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchstart", handleTouchStart);
      clearTimeout(hideTimeout);
    };
  }, [isBottomScreen]);

  const handleWhatsappClick = () => {
    window.location.href = "https://wa.link/hj33t3";
  };

  return (
    <Container
      onScroll={(event) => {
        handleScroll(event);
      }}
    >
      <StickyHeader>
        {/* <Announcement /> */}
        <Navbar activeMenuItem={activeComponent} />
      </StickyHeader>
      <VideoSlider />
      <Categories />
      <Portfolios />
      <AboutUs />
      <Appointment />
      {/* <Products /> */}

      {showScrollDown && (
        <>
          <ScrollDownLeftIcon>
            <ScrollDown backgroundColor={scrollIconBackgroundColor}>
              <KeyboardDoubleArrowDown htmlColor={scrollIconColor} />
            </ScrollDown>
            <ScrollDownLabel fontColor={scrollIconBackgroundColor}>
              Scroll down
            </ScrollDownLabel>
          </ScrollDownLeftIcon>

          <ScrollDownRightIcon>
            <ScrollDown backgroundColor={scrollIconBackgroundColor}>
              <KeyboardDoubleArrowDown htmlColor={scrollIconColor} />
            </ScrollDown>
            <ScrollDownLabel fontColor={scrollIconBackgroundColor}>
              Scroll down
            </ScrollDownLabel>
          </ScrollDownRightIcon>
        </>
      )}
      <WhatsappContainer onClick={handleWhatsappClick}>
        <WhatsappIcon src={"/whatsappIcon.svg"} />
      </WhatsappContainer>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100%;
  scroll-snap-type: y mandatory;
  scroll-snap-stop: inherit;
  scroll-behavior: smooth;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const StickyHeader = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 5;
  margin-bottom: 20px;
`;

const ScrollDownIconContainer = styled.div`
  width: 100%;
  gap: 28.5%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const ScrollDownLeftIcon = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 10px;
  left: 31%;
  @media (max-width: 768px) {
    left: 15%;
  }
`;

const ScrollDownRightIcon = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 10px;
  right: 31%;
  @media (max-width: 768px) {
    right: 15%;
  }
`;

const ScrollDown = styled.div`
  background-color: ${(props) => props.backgroundColor};
  padding: 5px;
  border-radius: 50%;
  display: flex;
`;

const ScrollDownLabel = styled.p`
  font-size: 14px;
  margin-top: 5px;
  color: ${(props) => props.fontColor};
`;

const WhatsappContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 5;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
    transform: scale(1.2);
  }
  @media (max-width: 768px) {
    bottom: 40px;
    right: 20px;
  }
`;

const WhatsappIcon = styled.img`
  display: flex;
  height: 50px;
  width: 50px;
  @media (max-width: 768px) {
    height: 45px;
    width: 45px;
  }
`;

export default Home;
